<template>
  <filter-wrapper
    class="numeric-filter"
    :label="field.label"
    :display-add-value-button="true"
    :removable="removable"
    @removeFilter="removeFilter"
    @addValue="addValue"
  >
    <div class="filter__content__values">
      <div
        class="filter__content__values__value"
        v-for="(value, index) in filterData.field.filter.values"
        :key="index"
      >
        <b-form-input
          type="number"
          v-model="value.min"
          placeholder="Минимум"
          class="filter__content__values__value__min"
        />
        <b-form-input
          type="number"
          v-model="value.max"
          placeholder="Максимум"
          class="filter__content__values__value__max"
        />
        <b-button
          variant="outline-danger"
          class="filter__content__values__value__remove-button"
          v-b-popover.hover.right="'Удалить значение'"
          @click="removeValue(value)"
        >
          <b-icon icon="x" />
        </b-button>
      </div>
    </div>
  </filter-wrapper>
</template>
<script>
import filterMixin from "@/components/Tables/Filters/mixins/filterMixin";
import FilterWrapper from "@/components/Tables/Filters/FilterWrapper";
export default {
  components: { FilterWrapper },
  mixins: [filterMixin],
  methods: {
    handler(item) {
      let searchValues = this.filterData.field.filter.values.filter(
        ({ min, max }) =>
          (!isNaN(min) && min !== null && min.length > 0) ||
          (!isNaN(max) && max !== null && max.length > 0)
      );
      if (searchValues.length > 0) {
        let val = item[this.field.key];
        if (typeof this.field.formatter === "function")
          val = this.field.formatter(val, this.field.key, item);
        return searchValues.some(({ min, max }) => {
          return !(
            (!isNaN(min) && min !== null && min > val) ||
            (!isNaN(max) && max !== null && max < val)
          );
        });
      } else return true;
    },
    addValue() {
      this.filterData.field.filter.values.push({ min: null, max: null });
    },
    removeValue(value) {
      this.filterData.field.filter.values.splice(
        this.filterData.field.filter.values.indexOf(value),
        1
      );
    }
  }
};
</script>
